import React, {useEffect, useRef} from 'react';
import {Form, Formik, useFormik} from 'formik';
import {setFormReviewAC} from 'app/popups-reducer';
import {useAppDispatch, useAppSelector} from 'common/hook';
import {ReactComponent as CloseIcon} from '../../assets/form/close-form.svg';
import {Rate} from 'antd';
import TextArea from 'antd/es/input/TextArea';
import {useInputWithFocus} from 'common/hook/useInputWithFocus';
import {useNavigate, useParams} from 'react-router-dom';
import {fetchReviewLesson} from "features/model/service/lessons/review-lesson/fetchReviewLesson";


export const FormReview = () => {
    const dispatch = useAppDispatch();
    const isFormReview = useAppSelector((state) => state.popups.isFormReview);
    const successResponse = useAppSelector((state) => state.reviewLesson.success);
    const successError = useAppSelector((state) => state.reviewLesson.error);
    const formRef: React.RefObject<HTMLDivElement> = useRef(null);

    const {groupId ,lessonsId} = useParams();

    const navigate = useNavigate();
    const {
        isFilled,
        handleFocus,
        handleBlur,
    } = useInputWithFocus([false]);

    const initialValues = {
        reviewText: '',
        points: 1,
    };


    const handleSubmit = () => {
        const data = {
            text: formik.values.reviewText,
            points: formik.values.points,
        };

        dispatch(fetchReviewLesson({reviewLesson: data, lessonsId}));
    };

    useEffect(() => {
        if (successResponse) {
            dispatch(setFormReviewAC(false));
            navigate(`groups/${groupId}/lessons/${lessonsId}`);
        }
    }, [successResponse]);


    const formik = useFormik({
        initialValues,
        onSubmit: handleSubmit,
    });

    const onClickHandler = () => {
        dispatch(setFormReviewAC(false));
        navigate(`groups/${groupId}/lessons/${lessonsId}`);
    };

    const handleOutsideClick = (e: MouseEvent) => {
        if (formRef.current) {
            const isClickInsideForm = formRef.current.contains(e.target as Node);
            if (!isClickInsideForm) {
                navigate(`groups/${groupId}/lessons/${lessonsId}`);
            }
        }
    };


    useEffect(() => {
        window.addEventListener('mousedown', handleOutsideClick);
        return () => {
            window.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);


    return (
        <div
            // ref={formRef}
            className={`popup form-popup ${isFormReview ? 'visible' : ''}`} id="lesson-review-popup"
            onClick={(e) => e.stopPropagation()}>
            <p className="h3 popup-title">Обратная связь<br/> по занятию</p>
            <Formik
                initialValues={initialValues}
                onSubmit={() => handleSubmit()}
            >
                {({isSubmitting}) => (
                    <Form
                        className="form"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                        }}
                    >
                        <div className="fields-row">
                            <div className="field">
                                <div className="star-rating">
                                    <Rate
                                        value={formik.values.points}
                                        onChange={(value) => formik.setFieldValue('points', value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="fields-row">
                            <div className={`field ${isFilled[0] ? 'filled' : ''} `}>
                                <label className={`field-name ${formik.values.reviewText ? 'active-label' : ''}`}>Текст
                                    отзыва</label>
                                <div className="textarea-box">
                                    <TextArea
                                        className="form-control"
                                        id="reviewText"
                                        name="reviewText"
                                        value={formik.values.reviewText}
                                        onChange={formik.handleChange}
                                        onFocus={() => handleFocus(0)}
                                        onBlur={handleBlur}
                                        autoSize={{minRows: 3, maxRows: 15}}
                                    />
                                </div>
                            </div>
                        </div>
                        <button type="submit" className="btn full-width" disabled={isSubmitting}>
                            <span>Отправить</span>
                        </button>
                    </Form>
                )}
            </Formik>
            <span onClick={onClickHandler} className="js-close-popup">
        <CloseIcon/>
        </span>
        </div>

    );
};
